// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { DomainPathRuleScopeSchema } from '../inputTypeSchemas/DomainPathRuleScopeSchema'

/////////////////////////////////////////
// DOMAIN PATH RULE SCHEMA
/////////////////////////////////////////

export const DomainPathRuleSchema = z.object({
  scope: DomainPathRuleScopeSchema,
  path: z.string(),
  isInFunctionalityScope: z.boolean(),
  isInTestingScope: z.boolean(),
  isThirdParty: z.boolean(),
})

export type DomainPathRule = z.infer<typeof DomainPathRuleSchema>

export default DomainPathRuleSchema;
